import { AccountPayments, getAccountPayments } from "../../../api/services";
import { useQuery } from "react-query";
import { usePagination } from "../../../hooks";

const PAGE_SIZE = 20;

export interface useAccountPaymentsResult {
  page: number;
  setPage: (page: number) => void;
  status: "loading" | "error" | "success";
  error: null | unknown;
  isFetching: boolean;
  data: AccountPayments | undefined;
}

export const useAccountPayments = (accountNumber: string) => {
  const { setPage, page } = usePagination("accounts/payments");

  const { isFetching, status, error, data } = useQuery(
    ["accounts/payments", { page, size: PAGE_SIZE, accountNumber }],
    getAccountPayments,
  );

  return {
    //Pagination Handlers
    page,
    setPage,
    pageSize: PAGE_SIZE,
    // Request Handlers
    status,
    isFetching,
    error,
    data: data?.results,
    count: data?.totalCount,
  };
};
